import { render } from "./MenuGeneral.vue?vue&type=template&id=18804183"
import script from "./MenuGeneral.vue?vue&type=script&lang=js"
export * from "./MenuGeneral.vue?vue&type=script&lang=js"

import "./MenuGeneral.vue?vue&type=style&index=0&id=18804183&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__